
<section> 
  <section id="about-info" class="bg-light py-3">
    <div class="container">
      <div class="info-left">
        <h1 class="l-heading"><span class="primary-text" style="color: #0a0101;">About</span> Fit ME</h1>
        <p style="color: black;">Here at Gym and Fitness, we have a team of approximately forty awesome superstars and we owe our success to each and every one of them! Because we hire for culture first and foremost, we have some pretty awesome people working with us who hustle everyday to give you a positive customer experience. </p>
        <p style="color: black;">You can find them in areas such as sales, marketing and ecommerce, customer service, warehousing, finance, human resources and management. If you think you’re kind of a big deal and interested in joining our team, please send us an email with your resume and a little bit about yourself..</p>
  
      </div>
      <div class="info-right">
        <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80" alt="ABout">

      </div>
    </div>
  </section>
  <div class="clr"></div>
  <section id="testimonials" class="py-3">
    <div class="container">
      <h2 class="l-heading">What Our Clients Say</h2>
      <div class="testimonial bg-primary">
        <img src="https://i7.behindwoods.com/model-women/prachi-mishra/thumbnails/related-section-image-prachi-mishra.jpg" alt="Vanshi">
        <p>This gym is amazing. Amazing facility, top equipment and great environment. Good service with friendly staff and super clean and comfortable gym for everyone from beginners to professional athletes to train at The classes are intense for every level athlete, and you will love the diverse workout combinations. I will definitely be returning for a round two, hope to see you there!</p>

      </div>
      <div class="testimonial bg-primary">
        <img src="https://i.pinimg.com/474x/1f/20/4f/1f204f5c3243895df40539669f6a5759.jpg" alt="Yukta">
        <p>Where do I start, this gym is what I think about when I think of the perfect gym. It started with the location and excellent breeze coming off the ocean. It quickly moved to the awesome energy and knowledge that you get from the trainers here, they are eager to help and will to take time with you. Also they understand what you are striving for and they WILL get you there and further, while having fun.</p>
        
      </div>

    </div>
  </section>
    


</section>
